<!-- Do not change this file. -->

<template>
  <div>
    <div class="container-fluid border-top py-2 text-small">
      <div class="d-flex justify-content-between" role="contentinfo">
        <div class="text-start my-auto">
          &copy; {{ year }} Oregon State University
        </div>

        <div class="text-end d-flex">
          <TheDebugger />
          <RouterLink
            :to="{ name: 'Admin' }"
            v-if="isAdmin && $route.name !== 'Admin'"
            class="nav-link ms-3 my-auto text-primary"
            >Admin</RouterLink
          >
          <RouterLink
            :to="{ name: 'Activity' }"
            v-if="isAdmin && $route.name === 'Admin'"
            class="nav-link ms-3 my-auto text-primary"
            >Activity</RouterLink
          >
          <button
            class="btn btn-link m-0 p-0 my-auto ms-3"
            @click="toggleVersion"
          >
            {{ version }}
          </button>
          <button
            class="btn btn-link m-0 p-0 my-auto ms-3"
            @click="openDataCollectionModal"
          >
            Data Collection
          </button>

          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/digital-millennium-copyright-act"
            >Copyright</a
          >

          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/official-web-disclaimer"
            >Disclaimer</a
          >
        </div>
      </div>
    </div>
    <DataCollectionModal ref="dataCollectionModal" />
  </div>
</template>

<script>
/* Do not change this file. */
import TheDebugger from "@/components/debug/TheDebugger";
import DataCollectionModal from "@/components/core/DataCollectionModal";

import { mapGetters } from "vuex";
import config from "@/data/config.json";

export default {
  name: "TheFooter",
  components: {
    TheDebugger,
    DataCollectionModal
  },
  data: () => {
    return {
      publishYear: config.meta.publishedYear,
      showVersion: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    year() {
      const currentYear = new Date().getFullYear(); // YYYY

      let yearString = "";
      /* Return just a single year */
      if (currentYear === this.publishYear) {
        yearString = `${currentYear}`;
      } else {
        /* Return a year range */
        yearString = `${this.publishYear} - ${currentYear}`;
      }

      return yearString;
    },
    version() {
      let version = "";

      if (this.showVersion) {
        version = document.lastModified;
      } else {
        version = require("./../../../package.json").version;
      }

      return version;
    }
  },
  methods: {
    toggleVersion() {
      this.showVersion = !this.showVersion;
    },
    openDataCollectionModal() {
      this.$refs.dataCollectionModal.openModal();
    }
  }
};
</script>

<style scoped>
.text-small {
  font-size: 0.8em;
}

.btn {
  font-size: inherit;
}

a,
.btn {
  text-decoration: none;
}

a:hover,
.btn:hover {
  text-decoration: underline;
}
</style>
